import styled from 'styled-components';
import {
  DESCRIPTION_MAX_LENGTH,
  IS_SCREENSHOT_MODE,
} from '../../../../config/constants';
import { EditableTextInput } from '../../../Form';
import { ChartMode } from '../../types';
import { useChartContext } from '../../ChartContext';
import { QueryType } from '../../../../utils/apollo/graphqlSchema';
import { theme } from '../../../../styles/theme';
import { assertCondition } from '../../../../utils/types';

const StaticDescription = styled.div`
  font-size: 10px;
  font-weight: 400;
  color: ${theme.colors.secondary600};
`;

const ChartHeaderDescription = () => {
  const chartContext = useChartContext();
  assertCondition(chartContext.__typename === 'BaseChartContext');
  const {
    metadata: { mode, description, queryType },
    actions: { updateDescription },
  } = chartContext;

  // Not supported in Cohorts
  if (queryType === QueryType.CohortSample) {
    return null;
  }

  if (IS_SCREENSHOT_MODE && !description) {
    return null;
  }

  if (mode === ChartMode.View) {
    if (!description) {
      return null;
    }

    return <StaticDescription>{description}</StaticDescription>;
  }

  return (
    <EditableTextInput
      value={description}
      onSubmit={updateDescription}
      limit={DESCRIPTION_MAX_LENGTH}
      placeholder="Enter a description for this chart..."
      inputSize="XS"
      allowEmpty={true}
      multiline={true}
    />
  );
};

export default ChartHeaderDescription;
